import { VYSION_ACTIONS } from '..';

const commonValues = {
  action: VYSION_ACTIONS.ON_FOCUS,
  page: 'Join',
  path: '/join',
};

export const enum JoinOnFocusVysionEventsEnum {
  FIRSTNAME = 'joinFirstname',
  PHONE_NUMBER = 'joinPhoneNumber',
  ENTER_NEW_PHONE_NUMBER = 'joinEnterANewNumberPhoneNumber',
  ENTER_PHONE_VERIFICATION_CODE = 'join-enterPhoneVerificationCode-enterCode',
}

export const joinOnFocusVysionEvents = {
  [JoinOnFocusVysionEventsEnum.FIRSTNAME]: {
    ...commonValues,
    component: 'First Name',
    eventName: 'join-firstname',
  },
};
